module.exports = __webpack_public_path__ + "img/jx3box_qqbot_logo.a940620f.svg";